import {getAppInfoApi, getLoginUserInfo, getAppMenuApi} from './api'

import {AppModel, MenuItem, Tenant, User} from 'galaxy-framework'
// model
import { FunctionItem } from 'marmot_design_ui'


export default class AppService {
    private deserialization = ({ subFunctionItems, ...other }: any) => {
        subFunctionItems = subFunctionItems ? subFunctionItems : [];
        let subFunctionItemList: FunctionItem[] = subFunctionItems.length
            ? subFunctionItems.map(
                (functionItem: any) => new FunctionItem(functionItem)
            )
            : [];
        return new FunctionItem({
            ...other,
            subFunctionItems: subFunctionItemList,
        });
    };
    getAppInfo = async ({
        appName = "",
        leftMenuApi = "",
        topBarUrl = ""
    }): Promise<AppModel> => {
        let { data: appInfo } = await getAppInfoApi(topBarUrl);
        let {data:d}=await getAppMenuApi({ appName, leftMenuApi });
        let functionItems=[];
        let entryRegedit=[];
        if(d.length){
            functionItems=d
        }else{
            functionItems=d.leftMenus
            entryRegedit=d.entryRegedit
        }
        let { data } = await getLoginUserInfo()
        let { menuItems, tenant, hasSearchBar } = appInfo
        let menuItemList = menuItems.map((menuItem: any) => new MenuItem(menuItem))
        let functionItemList = functionItems && functionItems.length && functionItems.map((functionItem: any) => this.deserialization(functionItem))
        tenant = new Tenant(tenant);
        let user = new User(data);
        return new AppModel({ menuItems: menuItemList, tenant, user, hasSearchBar,functionItems: functionItemList, entryRegedit, });
    };
}
